module.exports = __webpack_public_path__ + "img/help1.548f32f7.jpg";